<template>
  <div class="order-page">
    <el-card class="box-card">
      <!-- el-form -->
      <el-form :data="form"
               label-width="120px"
               style="width: 100%">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label-width
                          prop="create_time"
                          label="统计日期">
              <!-- <el-input v-model="form.create_time"></el-input> -->
              <el-date-picker type="monthrange"
                              style="width:100%"
                              v-model="form.create_time"
                              value-format="yyyy-MM"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width="120px"
                          prop="month"
                          label="月份">
              <number-range v-model="form.month"></number-range>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width
                          prop="type"
                          label="终端类型">
              <el-input v-model="form.type"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width
                          prop="from"
                          label="流量来源">
              <el-input v-model="form.from"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width
                          prop="from_detail"
                          label="来源明细">
              <el-input v-model="form.from_detail"
                        style="width:100%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="platCode"
                          label="行业">
              <el-select clearable
                         v-model="form.profession"
                         placeholder="请选择"
                         style="width: 100%">
                <el-option v-for="item in platlists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="business"
                          label="商家">
              <el-select v-loading="ptnListLoading"
                         clearable
                         v-model="form.business"
                         placeholder="请选择"
                         style="width: 100%">
                <el-option v-for="item in ptnlists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="store"
                          label="店铺">
              <el-select v-loading="shopListLoading"
                         clearable
                         v-model="form.store"
                         placeholder="请选择"
                         style="width: 100%">
                <el-option v-for="item in shoplists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card class="button-box">
      <action-line @action-line="handleActionLine"
                   :list="Desc.actionLine">
        <!-- <el-button @click="searchAreaStatus = !searchAreaStatus">{{ searchAreaStatus ? "收起" : "展开" }}</el-button> -->
      </action-line>
    </el-card>

    <!-- el-table -->
    <el-table v-loading="loading"
              height="calc(100vh - 100px)"
              border
              :data="tableData"
              style="width: 100%">
      <el-table-column prop="create_time"
                       align="center"
                       header-align="center"
                       label="统计日期"
                       width="100px"></el-table-column>
      <el-table-column prop="month"
                       align="center"
                       header-align="center"
                       label="月份"
                       width="60px"></el-table-column>

      <el-table-column prop="type"
                       align="center"
                       header-align="center"
                       label="终端类型"></el-table-column>
      <el-table-column prop="from"
                       align="center"
                       header-align="center"
                       label="流量来源"></el-table-column>
      <el-table-column prop="from_detail"
                       align="center"
                       header-align="center"
                       label="来源明细"></el-table-column>
      <el-table-column prop="visitor"
                       align="center"
                       header-align="center"
                       label="访客数"></el-table-column>
      <el-table-column prop="zfje"
                       align="center"
                       header-align="center"
                       label="支付金额"></el-table-column>
      <el-table-column prop="xdmjs"
                       align="center"
                       header-align="center"
                       label="下单买家数"></el-table-column>
      <el-table-column prop="xdje"
                       align="center"
                       header-align="center"
                       label="下单金额"></el-table-column>
      <el-table-column prop="xdzhlv"
                       align="center"
                       header-align="center"
                       label="下单转化率"></el-table-column>
      <el-table-column prop="zfmjs"
                       align="center"
                       header-align="center"
                       label="支付买家数"></el-table-column>
      <el-table-column prop="zfzhlv"
                       align="center"
                       header-align="center"
                       label="支付转化率"></el-table-column>
      <el-table-column prop="kdj"
                       align="center"
                       header-align="center"
                       label="客单价"></el-table-column>
      <el-table-column prop="uvjz"
                       align="center"
                       header-align="center"
                       label="UV价值"></el-table-column>
      <el-table-column align="center"
                       header-aligin="center"
                       prop="profession"
                       label="行业"
                       show-overflow-tooltip></el-table-column>
      <el-table-column align="center"
                       header-aligin="center"
                       prop="business"
                       label="商家"
                       show-overflow-tooltip></el-table-column>
      <el-table-column align="center"
                       header-aligin="center"
                       prop="store"
                       label="店铺"
                       min-width="130px"
                       show-overflow-tooltip></el-table-column>
    </el-table>
    <el-card>
      <el-row class="pagation-row">
        <el-pagination background
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page.sync="queryPrdlists.pagenum"
                       :page-size="queryPrdlists.pagesize"
                       :page-sizes="[10, 20, 50, 100]"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total"></el-pagination>
      </el-row>
    </el-card>
    <export-dialog ref="refExportDialog"
                   @submit="exportSubmit" />
    <import-dialog @submit="handleFile"
                   ref="refImportDialog" />
  </div>
</template>

<script>
import SearchMixin from '@/common/mixins/search-mixin'
import ActionLine from '@/common/mixins/action-line'
import { dealReturn } from '@/common/js/index.js'
import * as Desc from './desc'
export default {
  mixins: [ActionLine, SearchMixin],
  data() {
    return {
      form: {},
      loading: false,
      tableData: [],
      Desc,
    }
  },
  created() {
    // this.getTableData();
  },
  methods: {
    // async getTableData() {
    //   this.loading = true;
    //   let { data, err } = await this.axiosApi(
    //     Desc.list_api,
    //     this.queryPrdlists
    //   );
    //   // console.log("data", data);
    //   this.loading = false;
    //   this.tableData = data.data.data.data;
    //   this.total = parseInt(data.data.data.total);
    //   dealReturn(data, err);
    // },
  },
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/canmou/shopfrommonth/index.vue